import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
import classNames from 'classnames';

import { Spinner } from '../general';

interface Props {
  text: string;
  onClick: () => void;
  isSubmitting?: boolean;
  isDisabled?: boolean;
}

const FancyBtn: React.FC<Props> = (props) => {
  const { text, onClick, isSubmitting, isDisabled } = props;

  return (
    <button
      className="relative group max-w-full w-72 min-h-20 flex items-center justify-center uppercase text-xl font-bold text-lime-300 bg-true-black rounded-full border-4 border-lime-300 border-solid hover:bg-lime-300 hover:text-black disabled:pointer-events-none disabled:opacity-65"
      onClick={onClick}
      disabled={isDisabled}
    >
      <div
        className={classNames(
          'absolute flex items-center justify-center gap-2 transition-all duration-500',
          isSubmitting ? 'opacity-0' : 'opacity-100',
        )}
      >
        <Sparkle weight="fill" />
        <div>{text}</div>
      </div>

      <Spinner
        size="lg"
        color="lime"
        hoverColor="black"
        className={classNames(
          'absolute transition-all duration-500',
          isSubmitting ? 'opacity-100' : 'opacity-0',
        )}
      />
    </button>
  );
};

export default FancyBtn;
